import * as React from 'react';
import semanticClassNames from '../SearchButton.semanticClassNames';
import StylableButton from '../../StylableButton/viewer/skinComps/StylableButton/StylableButton.skin';
import type { IStylableButtonImperativeActions } from '../../StylableButton/StylableButton.types';
import type { ISearchButtonProps } from '../SearchButton.types';
import styles from './SearchButton.scss';

const SearchButton: React.ForwardRefRenderFunction<
  IStylableButtonImperativeActions,
  ISearchButtonProps
> = ({ isDisabled, customClassNames = [], ...props }, ref) => {
  return (
    <search className={styles.root}>
      <StylableButton
        {...props}
        ref={ref}
        semanticClassNames={semanticClassNames}
        customClassNames={customClassNames}
        isDisabled={isDisabled}
      />
    </search>
  );
};

export default React.forwardRef(SearchButton);
